"use client";
import React, { useContext, useState } from "react";

import { StyledButton } from "@stadium/ui/src/components/button/styled-button";

import { CurrentDeviceContext } from "@stadium/ui/src/contexts/responsive-content";

import Modal from "@stadium/ui/src/components/ModalNew";
import {
  ModalBody,
  ModalContent,
  ModalDialog,
  ModalFooter,
} from "@stadium/ui/src/components/ModalNew/utils";
import { VideoPlayer } from "@stadium/ui/src/components/video-player";

import defaultStyles from "./main.module.scss";

export const ModalVideo = ({
  video,
  closeModal,
  sliceStyles: styles = defaultStyles,
  isFeatureVideo,
}) => {
  const [isPlaying, setIsPlaying] = useState(false);
  const { isMobileDevice } = useContext(CurrentDeviceContext);

  const handlePlay = () => {
    setIsPlaying(true);
  };

  const handlePause = () => {
    setIsPlaying(false);
  };

  return (
    <Modal closeModal={closeModal} className={isFeatureVideo ? styles.videoModal : ""}>
      <ModalDialog className={styles.modalDialog}>
        <ModalContent className={styles.modalContentContainer}>
          <ModalBody className={styles.modalBody}>
            <div className={styles.videoContainer}>
              <VideoPlayer
                url={video.embed_url}
                autoPlay={isPlaying}
                height={isMobileDevice ? "280px" : "375px"}
                width="100%"
                onPause={handlePause}
                onPlay={handlePlay}
              />
            </div>
            {!isPlaying && (
              <div className={styles.videoHover}>
                <StyledButton
                  className={styles.playBtn}
                  onClick={() => handlePlay()}
                  styleType="no-style"
                ></StyledButton>
              </div>
            )}
          </ModalBody>
          <ModalFooter className={styles.modalFooter}>
            <StyledButton className={styles.doneButton} onClick={closeModal}>
              Done
            </StyledButton>
          </ModalFooter>
        </ModalContent>
      </ModalDialog>
    </Modal>
  );
};
